import Axios from "axios";
import { API_URL } from "../config/env";

export async function getStaticPage(
  pageName: string,
): Promise<any> {
  const { data: { data }, } = await Axios.get(`${API_URL}/web_site_info_pages?page_id=${pageName}`);
  return data
}
